module.exports = __webpack_public_path__ + "static/media/7.524c58f4.svg";